import styles from "./styles.scss";
import { FC, PropsWithChildren, useRef } from "react";
import clsx from "clsx";
import { useIntersectionObserver } from "@/hooks";
import { MobileHeader } from "@/components/mobile-header/mobile-header";
import { MobileTitleHeader } from "@/components/mobile-title-header";
import { MobileStickyTitleHeaderProps } from "./types";

export const MobileStickyTitleHeader: FC<
  PropsWithChildren<MobileStickyTitleHeaderProps>
> = ({
  title = "",
  pageTitleClassName,
  headerTitleClassName,
  children,
  isForceSetSticky = false,
  ...props
}) => {
  const titleRef = useRef<HTMLHeadingElement>(null);

  const isTitleInView = useIntersectionObserver(titleRef, {
    threshold: 0,
    rootMargin: "-44px 0px 0px 0px",
  });

  const isSticky = !isTitleInView || isForceSetSticky;

  return (
    <>
      {isSticky && (
        <div className={styles.stickyHeaderWrapper}>
          <MobileTitleHeader
            title={title}
            titleClassName={headerTitleClassName}
            {...props}
          >
            {children}
          </MobileTitleHeader>
        </div>
      )}

      <div className={styles.headerMobile}>
        <MobileHeader className={styles.nonSticky} {...props}>
          {children}
        </MobileHeader>

        <h1
          ref={titleRef}
          className={clsx(
            styles.pageTitle,
            isSticky && styles.hidden,
            pageTitleClassName,
          )}
        >
          {title}
        </h1>
      </div>
    </>
  );
};
